import { Apps, Workspaces } from "@mui/icons-material";
import { Badge } from "@mui/material";
import { ReactNode } from "react";
import { Permission, permissions } from "src/grading/utils/permissionsHelpers";
import {
  AthletesMenuIcon,
  ChatIcon,
  LiveIcon,
  LogoutIcon,
  MyLibraryIcon,
  ProfileIcon,
} from "../../assets";

export interface NavLink {
  path: string;
  name: string;
  icon?: ReactNode;
  childLinks?: NavLink[];
  isOpen?: boolean;
  openInNewTab?: boolean;
  onClick?: () => void;
  permission?: Permission;
  parent?: string;
}

export const standardLinks: NavLink[] = [
  {
    name: "Organization",
    path: "/grading/organization",
    icon: <Workspaces style={{ color: "white" }} />,
    permission: permissions.READ_ORGANIZATION,
  },
  {
    name: "Athletes",
    path: "/grading/athletes",
    icon: <AthletesMenuIcon />,
    permission: permissions.READ_ATHLETES,
  },
  {
    name: "Testing",
    path: "",
    icon: <LiveIcon />,
    permission: permissions.READ_LIVE_TESTS,
    childLinks: [
      {
        name: "Live Testing",
        path: "/grading/live",
        permission: permissions.READ_LIVE_TESTS,
        parent: "Testing",
      },
      {
        name: "Virtual Testing",
        path: "/grading/pending",
        permission: permissions.READ_PENDING_TESTS,
        parent: "Testing",
      },
      {
        name: "Certified Tests",
        path: "/grading/certified",
        permission: permissions.READ_CERTIFIED_TESTS,
        parent: "Testing",
      },
    ],
  },
  {
    name: "My library",
    path: "",
    icon: <MyLibraryIcon />,
    childLinks: [
      {
        name: "Plan templates",
        path: "/my-library/plan-templates",
        parent: "My library",
      },
      {
        name: "Workouts",
        path: "/my-library/workouts",
        parent: "My library",
      },
      {
        name: "Exercises",
        path: "/my-library/exercises",
        parent: "My library",
      },
    ],
  },

  // Admin
  {
    name: "Demo Tests",
    path: "/grading/admin/demo-tests",
    icon: <Apps style={{ color: "white" }} />,
    permission: permissions.READ_DEMO_TESTS,
  },
];

export const getBottomLinks = (unreadMessagesCount: number) => {
  return [
    {
      name: "Chat",
      path: "/chat",
      icon: (
        <Badge
          badgeContent={unreadMessagesCount > 0 ? unreadMessagesCount : null}
          color="error"
          sx={{
            "& .MuiBadge-badge": {
              right: -3,
              top: 3,
            },
          }}
        >
          <ChatIcon />
        </Badge>
      ),
    },
    { name: "Profile", path: "/grading/profile", icon: <ProfileIcon /> },
    {
      name: "Logout",
      path: "/logout",
      onClick: () => {
        window.localStorage.removeItem("readyFitAuth");
        window.localStorage.removeItem("userInfo");
        window.location.replace("/grading");
      },
      icon: <LogoutIcon />,
    },
  ];
};
